import React from 'react'
import styles from './TableContainer.module.scss'
import cl from 'classnames'
import { TableContainerProps } from './TableContainer.types'

const TableContainerComponent = (props: TableContainerProps) => {
  const {
    className,
    noBoxShadow,
    ...rest
  } = props

  return (
    <div
      className={cl(styles.tableContainer, { [styles.noBoxShadow]: noBoxShadow }, className)}
      {...rest}
    />
  )
}

const TableContainer = TableContainerComponent
export { TableContainer }
